export var VISIBLE_COLUMNS_COUNT = 10;
export var COLUMN_WIDTH = 74;
export var LAST_COLUMN_WIDTH = 36;
export var CHEVRON_COLUMN_WIDTH = 24;
export var ROW_HEIGHT = 54;
export var SUB_ROW_PADDING_TOP = 12;
export var SCROLL_OFFSET_Y = 210;
export var FILTER_COLUMN_ID = 'help-needed';
